/**
 * PrivateRoute — route guard: redirects to /login without a session and
 * shows 403 when the user's roles (from the decoded JWT) don't overlap
 * allowedRoles. UI-level protection only — the backend enforces the same
 * rules independently via its guards.
 */
import React from "react";
import { Outlet } from 'react-router-dom';

import { MainLayout } from "components/Layout";

import { useSelector } from "react-redux";
import  { Navigate } from 'react-router-dom'
import { E403Page } from "components/Pages";
import { intersection } from "lodash";

const PrivateRoute = ({ allowedRoles }) => {
  const auth = useSelector((state) => state.auth);
  
  // check auth, role
  if (!auth.authenticated) {
    return <Navigate to={{ pathname: "/login" }} />;
  }
  const roles = auth.userData.roles || [];
  if (!intersection(allowedRoles, roles).length > 0) {
    return <E403Page />;
  }

  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
}

export default PrivateRoute;
